import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { HomeTypeFailure, HomeTypeRequest, HomeTypeSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'homeType';

export interface State {
  data: ParameterResult | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(HomeTypeFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(HomeTypeRequest, state => ({ ...state, error: null, loading: true })),
    on(HomeTypeSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
